module.exports = __webpack_public_path__ + "static/lframe-kiwibank-car-loans-9c5250f066030b7efede9edc82ddf6bb.webp";